import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/pme',
		component: Base,
		children: [
			{
				path: '',
				name: 'PMEList',
				component: List,
				meta: {
					path: '/links/pme',
					pai: 'Links',
					title: 'Admin - Plano M de Educação',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano M de Educação',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PMENovo',
				component: Form,
				meta: {
					path: '/links/pme',
					pai: 'Links',
					title: 'Admin - Plano M de Educação - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano M de Educação',
						class: '',
						active: false,
						url: '/links/pme'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PMEEditar',
				component: Form,
				meta: {
					path: '/links/pme',
					pai: 'Links',
					title: 'Admin - Plano M de Educação - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano M de Educação',
						class: '',
						active: false,
						url: '/links/pme'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]